import { Component, OnInit, NgZone, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { interval } from 'rxjs';
import { RestfulService } from './shared/services/restful.service';
import { CoreService } from './shared/services/core.service';
import { BleUtils } from './ble';
import * as locales from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';

import { Platform } from '@ionic/angular';

import moment from 'moment';
import 'moment/min/locales';
import { NavigationEnd, Router } from '@angular/router';
import { ScreenSizeService } from './shared/services/screen-size.service';
import { startWith, switchMap } from 'rxjs/operators';

import { AppConfigService } from './app-config.service';
function defineLocales() {
  for (const locale in locales) {
    defineLocale(locales[locale].abbr, locales[locale]);
  }
}

declare var blePeripheral;
declare var ble;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  
  standalone: false
})
export class AppComponent implements OnInit {
  public hideToolbar: boolean = false;
  public isMobile: boolean = false;
  somethingChanged = false;
  properties = [];
  ble: BleUtils;
  userDetails: any;
  constructor(
    private zone: NgZone,
    public translate: TranslateService,
    public restServ: RestfulService,
    public coreService: CoreService,    
    private router: Router,
    public screenSizeService: ScreenSizeService,
    private platform: Platform,
    private renderer: Renderer2,
    private platformService: AppConfigService
  ) {
    this.screenSizeService.ScreenSize.subscribe((res: number) => {
      this.isMobile = res <= 991;
      this.checkHideToolbar();
    });
    translate.addLangs([
      'en',
      'it',
      'pl',
      'es',
      'pt',
      'nl',
      'de',
      'zh',
      'fr',
      'ru'
    ]);
    translate.setDefaultLang('en');
    defineLocales();
    const lang = translate.getBrowserLang();

    translate.use(lang.match(/en|it|pl|nl|es|pt|de|ru|fr|zh/) ? lang : 'en');
    moment.locale(lang);
    if (lang === 'zh') {
      moment.locale(lang + '-cn');
    }
  }

  ngOnInit() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        // console.log(e.url);
        this.checkHideToolbar();
      }
    });
    if (this.platformService.isMacChrome()) {
      this.renderer.addClass(document.body, 'mac-chrome');
    }
    // Cordova platform and plugins initialization
    // document.addEventListener('deviceready', () => {
    //   console.log('deviceready');
    //   this.zone.run(() => this.onCordovaReady());
    // }, false);
    this.platform.ready().then((readySource) => {
      console.log('Platform ready from ' + readySource);
    });
    // interval(60 * 1000) //60 seconds
    //   .subscribe(() => {
    //     this.getUpdatedUserInfo();
    //   });
  }

  async ngAfterViewInit() {
    this.userDetails = await this.coreService.getUserInfo();
    await this.getUpdatedUserInfo();
  }
  get isLoggedIn() {
    const url = this.router.url;
    return this.coreService.isLoggedIn() && !url.includes('choose-login');
  }

  checkHideToolbar() {
    let hideListUrls = [];

    hideListUrls.push('/OKRs/report/myOKRs');
    hideListUrls.push('/MyWallet/exchange-tokens');
    hideListUrls.push('/MyWallet/my-coupons');
    hideListUrls.push('/MyWallet/patpoints');
    hideListUrls.push('/PartecipantLTI/recipent');
    hideListUrls.push('/Personal-Growth/employee-personal-growth/praise');
    hideListUrls.push('/User/opinion');

    this.hideToolbar = this.isMobile && hideListUrls.includes(this.router.url);
  }

  getUserInfoObserver = {
    next: (userInfo: any) => {
      const currentUserInfo = this.coreService.getUserInfo();
      this.somethingChanged = false;
      this.properties = [];
      this.changeProperty(currentUserInfo, userInfo, 'availableTokens');
      this.changeProperty(currentUserInfo, userInfo, 'canAddNews');
      this.changeProperty(currentUserInfo, userInfo, 'earnedTokens');
      this.changeProperty(currentUserInfo, userInfo, 'evaluateFeedbackAuthor');
      this.changeProperty(currentUserInfo, userInfo, 'fullName');
      this.changeProperty(currentUserInfo, userInfo, 'hasBossEvaluation');
      this.changeProperty(currentUserInfo, userInfo, 'hasEvaluationFeed');
      this.changeProperty(currentUserInfo, userInfo, 'hasPatFeed');
      this.changeProperty(currentUserInfo, userInfo, 'hasSkills');
      this.changeProperty(currentUserInfo, userInfo, 'hasBehaviors');
      this.changeProperty(currentUserInfo, userInfo, 'hasPatPrize');
      this.changeProperty(currentUserInfo, userInfo, 'hasObjectives');
      this.changeProperty(currentUserInfo, userInfo, 'hasSelfEvaluations');
      this.changeProperty(currentUserInfo, userInfo, 'hasObjectiveCycles');
      this.changeProperty(currentUserInfo, userInfo, 'imageUrl');
      this.changeProperty(currentUserInfo, userInfo, 'isEvaluator');
      this.changeProperty(currentUserInfo, userInfo, 'isManager');
      this.changeProperty(currentUserInfo, userInfo, 'jobRole');
      this.changeProperty(currentUserInfo, userInfo, 'language');
      this.changeProperty(currentUserInfo, userInfo, 'defaultlanguage');
      this.changeProperty(currentUserInfo, userInfo, 'belongingCompanyLogo');
      this.changeProperty(currentUserInfo, userInfo, 'belongingCompanyStyle');
      this.changeProperty(currentUserInfo, userInfo, 'belongingCompanyName');
      this.changeProperty(currentUserInfo, userInfo, 'roles');
      this.changeProperty(currentUserInfo, userInfo, 'receiveEvaluationFeed');
      this.changeProperty(currentUserInfo, userInfo, 'receivePatFeed');
      this.changeProperty(currentUserInfo, userInfo, 'hasTokenFeed');
      this.changeProperty(currentUserInfo, userInfo, 'receiveTokenFeed');
      this.changeProperty(currentUserInfo, userInfo, 'hasAnonymous');
      this.changeProperty(currentUserInfo, userInfo, 'hasTokenExchangers');

      this.changeProperty(
        currentUserInfo,
        userInfo,
        'hasSkillAdvancedSettings'
      );
      this.changeProperty(currentUserInfo, userInfo, 'hasScalesCustomization');
      this.changeProperty(currentUserInfo, userInfo, 'hasMultilanguage');
      this.changeProperty(currentUserInfo, userInfo, 'hasColorCustomizations');
      this.changeProperty(currentUserInfo, userInfo, 'hasLTI');

      this.changeProperty(currentUserInfo, userInfo, 'hasSurveys');
      this.changeProperty(currentUserInfo, userInfo, 'hasONA');
      this.changeProperty(currentUserInfo, userInfo, 'hasPerformanceReview');
      this.changeProperty(currentUserInfo, userInfo, 'hasTableauItegration');

      // if(window['cordova']){
      //   window['cordova'].plugins['notification'].badge.set(userInfo.NewNotifications);
      // }
      if (
        userInfo.NewNotifications > 0 ||
        userInfo.NewNotifications != currentUserInfo['StoredNotifications']
      ) {
        this.coreService.hasNewNotification();
        currentUserInfo['StoredNotifications'] = userInfo.NewNotifications;
        this.somethingChanged = true;
      }

      if (
        !currentUserInfo['EvaluationScale'] ||
        JSON.stringify(currentUserInfo['EvaluationScale']) !=
          JSON.stringify(userInfo['EvaluationScale'])
      ) {
        //WALL Is Changed
        currentUserInfo['EvaluationScale'] = userInfo['EvaluationScale'];
        this.coreService.setUserInfo(currentUserInfo);
        this.coreService.changedProperty('EvaluationScale');
      }

      if (
        !currentUserInfo['userCycles'] ||
        JSON.stringify(currentUserInfo['userCycles']) !=
          JSON.stringify(userInfo['userCycles'])
      ) {
        //WALL Is Changed
        currentUserInfo['userCycles'] = userInfo['userCycles'];
        this.coreService.setUserInfo(currentUserInfo);
        this.coreService.changedProperty('userCycles');
      }
      if (
        !currentUserInfo['viewCycles'] ||
        JSON.stringify(currentUserInfo['viewCycles']) !=
          JSON.stringify(userInfo['viewCycles'])
      ) {
        //WALL Is Changed
        currentUserInfo['viewCycles'] = userInfo['viewCycles'];
        this.coreService.setUserInfo(currentUserInfo);
        this.coreService.changedProperty('viewCycles');
      }

      if (
        !currentUserInfo['wallDate'] ||
        currentUserInfo['wallDate'] != userInfo['wallDate']
      ) {
        //WALL Is Changed
        currentUserInfo['wallDate'] = userInfo['wallDate'];
        this.coreService.setUserInfo(currentUserInfo);
        this.coreService.onWallChanged();
      }

      if (this.somethingChanged) {
        this.coreService.setUserInfo(currentUserInfo);
        this.coreService.changedProperty(this.properties);
      }
      if (currentUserInfo) {
        if (currentUserInfo.PreferredRole) {
          if (currentUserInfo.PreferredRole === 'Manager') {
            if (!currentUserInfo.isManager) {
              this.router.navigate(['choose-login']);
            }
          } else {
            const role =
              currentUserInfo.roles.indexOf(currentUserInfo.PreferredRole) !==
              -1;
            if (!role) {
              this.router.navigate(['choose-login']);
            }
          }
        }
      }
      // Prefer locally persisted user theme to avoid temporary server stale responses
      // reverting the UI right after a manual theme change.
      this.changeTheme(currentUserInfo?.Theme || userInfo.Theme);
    }
  };

  async changeTheme(theme) {
    if (theme) {
      document.documentElement.style.setProperty('--white', '#' + theme.RGB1);
      document.documentElement.style.setProperty(
        '--feed-background',
        '#' + theme.RGB2
      );
      document.documentElement.style.setProperty(
        '--login-textfield-color',
        '#' + theme.RGB3
      );
      document.documentElement.style.setProperty(
        '--login-textfield-border',
        '#' + theme.RGB4
      );
      document.documentElement.style.setProperty(
        '--login-text-color',
        '#' + theme.RGB5
      );
      document.documentElement.style.setProperty(
        '--login-button',
        '#' + theme.RGB6
      );
      document.documentElement.style.setProperty(
        '--login-text-error',
        '#' + theme.RGB7
      );
      document.documentElement.style.setProperty(
        '--login-button-hover',
        '#' + theme.RGB8
      );
      document.documentElement.style.setProperty(
        '--okr-green',
        '#' + theme.RGB9
      );
    }
    if (theme?.VariationCode === 'F' || theme?.VariationCode === 'D') {
      document.documentElement.style.setProperty('--shadow-color', '#ffffff80');
      document.body.classList.add('flipColor');
      this.userDetails = await this.coreService.getUserInfo();
      // await this.getUpdatedUserInfo();
    } else {
      document.body.classList.remove('flipColor');
      document.documentElement.style.setProperty('--shadow-color', '#00000080');
      this.userDetails = await this.coreService.getUserInfo();
      // await this.getUpdatedUserInfo();
    }
  }

  changeProperty(currentItem, newItem, property) {
    if (currentItem[property] != newItem[property]) {
      currentItem[property] = newItem[property];
      this.somethingChanged = true;
      this.properties.push(property);
    }
  }

  getUpdatedUserInfo() {
    return interval(60 * 1000)
      .pipe(
        startWith(0),
        switchMap(() => this.restServ.get(`Account/UserInfo`))
      )
      .subscribe(this.getUserInfoObserver);
  }

 
}
  

